import Vue from 'vue'
import { formatToCurrency } from '@/helpers/numeralFormat'

Vue.filter('currency', function (value) {
    return formatToCurrency(value)
})
